import { NgModule } from '@angular/core';

import { Section06Component } from './section06.component';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        Section06Component
    ],
    imports: [
        TranslateModule,
        CommonModule,
        RouterModule,
        LocalizeRouterModule
    ],
    exports: [
        Section06Component
    ]
})

export class Section06Module { }
